import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { Link, IndexLink } from 'react-router';

import * as collectionActions from '../../actions/collectionActions';
import CollectionApi from '../../api/mockCollectionApi';
import * as recipeActions from '../../actions/recipeActions';
import RecipeApi from '../../api/mockRecipeApi';
import RecipeList from './RecipeList';
import RecipeFilter from './RecipeFilter';
import RecipeComponent from '../recipes/RecipeComponent';
import CollectionLayout from './CollectionLayout';


class CollectionPage extends React.Component {
	//container component part 1:  set state and bind actions to component
	constructor(props, context) {
		super(props, context);

		this.state = {
			collectionView: "grid",
			filterClass: "inactive",
			currentFilter: {"readingLevel":[],"authorLastName":[]},
			currentSort: "newest",
			recipesContainerClass: "inactive"
		};

		this.filterRecipes = this.filterRecipes.bind(this);
		this.sortRecipes = this.sortRecipes.bind(this);
		this.toggleFilter = this.toggleFilter.bind(this);
		this.changeView = this.changeView.bind(this);
		this.goToRecipe = this.goToRecipe.bind(this);
		this.closeRecipes = this.closeRecipes.bind(this);
	}

	componentDidMount() {
		this.dispatchCollection(this.props.collection); //set state here for pages loaded via URL
	}

	componentWillReceiveProps(nextProps) { //USED WHEN SAME COMPONENT IS USED FOR NEXT ROUTE OR QUERY (i.e. /book/1 -> /book/2).  Component doesn't remount, but receives new props.
		if (this.props.collection[0]._id !== nextProps.collection[0]._id) {
			this.dispatchCollection(nextProps.collection); //set state here for pages loaded via URL
		}
	}

	//container component part 2:  child functions
	dispatchCollection(collection) {
		this.props.actions.collectionActions.loadCollection(collection);
	}

	filterRecipes(event) {
		event.stopPropagation();
		let thisBox = event.currentTarget.value; //checkbox value
		let thisField = event.currentTarget.getAttribute("data-field"); //which field in the filter array to push to
		let currentFilter = this.state.currentFilter;	
		if (currentFilter[thisField].indexOf(thisBox) > -1) {
			currentFilter[thisField].splice(currentFilter[thisField].indexOf(thisBox), 1);
		} else {
			currentFilter[thisField].push(thisBox);
		}
		this.dispatchRecipes(this.props.collection,currentFilter,this.state.currentSort);
	}

	sortRecipes(event) {
		event.stopPropagation();
		let sort = event.currentTarget.getAttribute("data-sort");
		this.setState({currentSort: sort});
		this.dispatchRecipes(this.props.collection,this.state.currentFilter,sort); //dispatch books but not library - need to do this to update "slideshow" order, otherwise could do this in local state
	}

	dispatchRecipes(collection,filter,sort) {
		this.props.actions.recipeActions.loadRecipes(collection,filter,sort);
	}

	dispatchRecipe(recipe) {
		this.props.actions.recipeActions.loadRecipe(recipe);
	}


	toggleFilter() {
		let css = (this.state.filterClass === "inactive") ? "active" : "inactive";
		this.setState({filterClass:css});
	}

	changeView(event) {
		let view = event.currentTarget.getAttribute("data-view");
		this.setState({collectionView: view});
	}

	goToRecipe(event) {
		event.preventDefault();
		let recipeId = event.currentTarget.getAttribute("data-recipe");
		this.dispatchRecipe(recipeId);
		this.setState({recipesContainerClass: "active"});
	}

	closeRecipes() {
		this.setState({recipesContainerClass: "inactive"});
	}

	//container component part 3:  display component (should not be straight HTML)
	render() {
		const {collection} = this.props;
		const {recipes} = this.props;
		const {recipe} = this.props;

		let collectionReady = false;
		if (collection.length != 0) {
			collectionReady = true;
		}
		let recipesReady = false;
		if (recipes.length != 0) {
			recipesReady = true;
		}
		let recipeReady = false;
		if (recipe.length != 0) {
			recipeReady = true;
		}

		return (
			<div className="collection-page">
				{collectionReady && <h1>Collection: {collection[0].name}</h1>}
				{recipesReady && <RecipeList 
					recipes={recipes} 
					collectionView={this.state.collectionView}
					goToRecipe={this.goToRecipe}
				/>}
				{recipesReady && <CollectionLayout 
					toggleFilter={this.toggleFilter}
					changeView={this.changeView}
					firstRecipe={recipes[0]}
				/>}			
				{recipesReady && <RecipeFilter  
					toggleFilter={this.toggleFilter}
					filterClass={"filter-modal " + this.state.filterClass}
					filterRecipes={this.filterRecipes}
					sortRecipes={this.sortRecipes}
				/>}
				{recipeReady && <div className={"recipes-modal " + this.state.recipesContainerClass}>
					<RecipeComponent closeRecipes={this.closeRecipes}/>
				</div>}
			</div>
		);
	}
}

//container component part 4:  propTypes validation
CollectionPage.propTypes = {
	collection: PropTypes.array.isRequired,
	recipes: PropTypes.array.isRequired,
	recipe: PropTypes.array.isRequired,
	actions: PropTypes.object.isRequired
};

function getCollectionById(collections, _id) {
	const collection = collections.filter(collection => collection._id.$oid == _id);
	//console.log(library);
	if (collection.length) return collection[0];
	return null;
}

//container component part 5:  connect and dispatch to Redux
function mapStateToProps(state, ownProps) {
	
	const collectionId = ownProps.params._id; //get the path '/library/:_id'
	
	let collection = [{
	"_id": 0,
	"id": 0, 
	"userId": 0, 
	"name": 'Browse', 
	"type": '', 
	"books": [], 
	"recommendTo": []
	}];

	if (collectionId && state.collections.length > 0) { //not loading directly via URL here, so library has to be loaded into users libraries list.  need to catch and redirect null.
		collection = getCollectionById(state.collections, collectionId);
		collection = [collection];
	}

	return {
		collection: collection,
		recipes: state.recipes,
		recipe: state.recipe
	};
}

function mapDispatchToProps(dispatch) {
	//debugger;
	return {
		actions: {
			collectionActions: bindActionCreators(collectionActions, dispatch),
			recipeActions: bindActionCreators(recipeActions, dispatch)
		}
	};
}

export default connect(mapStateToProps,mapDispatchToProps)(CollectionPage);


/** WEBPACK FOOTER **
 ** ./src/components/collections/CollectionPage.js
 **/